'use client';

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={`flex items-center font-extrabold text-sm uppercase tracking-[0.18em] ${className}`}>
      <span className="text-foreground">CAREER</span>
      <span className="text-[var(--burgundy-core)]">OFFENSIVE</span>
    </div>
  );
};

export const Logomark = ({ className }: { className?: string }) => {
  return (
    <div className={`flex items-center font-extrabold text-sm uppercase tracking-[0.18em] ${className}`}>
      <span className="text-foreground">CAREER</span>
      <span className="text-[var(--burgundy-core)]">OFFENSIVE</span>
    </div>
  );
};

export default Logomark;
